/** @format */
export enum DynamicProductTemplateModules {
	BUNDLE_DEFAULT = 'pdp_bundle',
	CUSTOM_DEFAULT = 'pdp_custd',
	IN_STOCK_DEFAULT = 'pdp_isd',
	NOT_FOUND_DEFAULT = 'pdp_404',
	OUT_OF_STOCK_DEFAULT = 'pdp_oosd'
}
